<template>
  <v-container grid-list-xl fluid>
    <!-- TABLA DOCUMENTO -->
    <div v-if="loading">
      <loading></loading>
    </div>
    <grid-capacitacion
      :key="gridDocumento"
      :rowsTable="rowsTable"
      :contratoId="idContrato"
    ></grid-capacitacion>
    <!-- TABLA DOCUMENTO -->
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridCapacitacion from "@/modules/aplicacion/views/seleccion/capacitacion/GridCapacitacion.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "capacitacion-seleccion-tab",

  components: {
    GridCapacitacion,
    Loading,
  },

  props: {
    tabSelected: "",
    idContrato: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],

      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      botonesUsuario: 0,
      gridDocumento: 20,
    };
  },

  mounted() {},
  created() {
    this.proceso = this.$store.getters.proSelectedStored;
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
  },
};
</script>
